import React from 'react';

const Layout = (props) => {
  return (
    <div className='bs-layout'>
      {props.children}
    </div>
  )
}

export default Layout;